


// import React, { useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import { Form, Input, Button, Card, Typography, Alert, Row, Col, Checkbox, Tooltip, Progress, message } from "antd";
// import {
//   UserOutlined,
//   LockOutlined,
//   MailOutlined,
//   LoadingOutlined,
//   BookOutlined,
//   TeamOutlined,
//   TrophyOutlined,
//   RocketOutlined,
//   StarOutlined,
//   BulbOutlined,
//   CheckCircleOutlined,
//   SecurityScanOutlined,
//   InfoCircleOutlined,
//   EyeInvisibleOutlined,
//   EyeTwoTone
// } from "@ant-design/icons";

// import { register } from "../actions/auth";

// const { Title, Paragraph, Text } = Typography;

// const Register = () => {
//   const [form] = Form.useForm();
//   const [username, setUsername] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [successful, setSuccessful] = useState(false);
//   const [acceptTerms, setAcceptTerms] = useState(false);
//   const [acceptPrivacy, setAcceptPrivacy] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState(0);
//   const [passwordCriteria, setPasswordCriteria] = useState({
//     length: false,
//     uppercase: false,
//     lowercase: false,
//     number: false,
//     special: false
//   });

//   const { message: errorMessage } = useSelector(state => state.message);
//   const dispatch = useDispatch();

//   // Fonction pour vérifier la force du mot de passe
//   const checkPasswordStrength = (password) => {
//     const criteria = {
//       length: password.length >= 8,
//       uppercase: /[A-Z]/.test(password),
//       lowercase: /[a-z]/.test(password),
//       number: /\d/.test(password),
//       special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
//     };

//     setPasswordCriteria(criteria);

//     const score = Object.values(criteria).filter(Boolean).length;
//     setPasswordStrength((score / 5) * 100);

//     return score >= 4; // Au moins 4 critères sur 5 doivent être remplis
//   };

//   const getPasswordStrengthColor = () => {
//     if (passwordStrength < 40) return '#ff4d4f';
//     if (passwordStrength < 70) return '#faad14';
//     return '#52c41a';
//   };

//   const getPasswordStrengthText = () => {
//     if (passwordStrength < 40) return 'Faible';
//     if (passwordStrength < 70) return 'Moyen';
//     return 'Fort';
//   };

//   const handleRegister = (values) => {
//     if (!acceptTerms || !acceptPrivacy) {
//       message.error("Veuillez accepter les conditions d'utilisation et la politique de confidentialité.");
//       return;
//     }

//     if (!checkPasswordStrength(values.password)) {
//       message.error("Le mot de passe ne respecte pas les critères de sécurité requis.");
//       return;
//     }

//     setLoading(true);
//     setSuccessful(false);

//     // Appel de l'action register avec tous les paramètres nécessaires
//     dispatch(register(
//       values.username,
//       values.email,
//       values.password,
//       values.confirmPassword,
//       acceptTerms,
//       acceptPrivacy
//     ))
//       .then(() => {
//         setSuccessful(true);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSuccessful(false);
//         setLoading(false);
//       });
//   };

//   if (successful) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           padding: "20px",
//         }}
//       >
//         <Card
//           style={{
//             width: "100%",
//             maxWidth: "500px",
//             background: "rgba(255, 255, 255, 0.95)",
//             borderRadius: "20px",
//             boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
//             backdropFilter: "blur(10px)",
//             border: "none",
//             textAlign: "center",
//           }}
//           bodyStyle={{ padding: "50px" }}
//         >
//           <div
//             style={{
//               background: "linear-gradient(45deg, #52c41a, #73d13d)",
//               borderRadius: "50%",
//               width: "80px",
//               height: "80px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               margin: "0 auto 30px",
//               boxShadow: "0 10px 30px rgba(82, 196, 26, 0.3)",
//             }}
//           >
//             <CheckCircleOutlined style={{ fontSize: "32px", color: "white" }} />
//           </div>

//           <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
//             Inscription réussie !
//           </Title>

//           <Paragraph style={{ color: "#666", fontSize: "16px", marginBottom: "30px" }}>
//             Votre compte a été créé avec succès. Un email de confirmation a été envoyé à votre adresse.
//             Veuillez confirmer votre email pour commencer votre parcours d'apprentissage sur Nomidya.
//           </Paragraph>

//           <Link to="/login">
//             <Button
//               type="primary"
//               size="large"
//               style={{
//                 background: "linear-gradient(45deg, #667eea, #764ba2)",
//                 border: "none",
//                 borderRadius: "10px",
//                 height: "50px",
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
//                 minWidth: "200px",
//               }}
//             >
//               Se connecter
//             </Button>
//           </Link>
//         </Card>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
//         display: "flex",
//         alignItems: "center",
//         padding: "20px 0",
//       }}
//     >
//       <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
//         <Row gutter={[40, 40]} align="middle">
//           {/* Section Description */}
//           <Col xs={24} lg={12}>
//             <div
//               style={{
//                 background: "rgba(255, 255, 255, 0.95)",
//                 borderRadius: "20px",
//                 padding: "40px",
//                 boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
//                 backdropFilter: "blur(10px)",
//               }}
//             >
//               {/* Logo et titre principal */}
//               <div style={{ textAlign: "center", marginBottom: "30px" }}>
//                 <div
//                   style={{
//                     background: "linear-gradient(45deg, #667eea, #764ba2)",
//                     borderRadius: "50%",
//                     width: "80px",
//                     height: "80px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     margin: "0 auto 20px",
//                     boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
//                   }}
//                 >
//                   <RocketOutlined style={{ fontSize: "32px", color: "white" }} />
//                 </div>
//                 <Title
//                   level={1}
//                   style={{
//                     background: "linear-gradient(45deg, #667eea, #764ba2)",
//                     WebkitBackgroundClip: "text",
//                     WebkitTextFillColor: "transparent",
//                     marginBottom: "10px",
//                     fontSize: "2.5em"
//                   }}
//                 >
//                   NOMIDYA
//                 </Title>
//                 <Text style={{ fontSize: "18px", color: "#666" }}>
//                   Rejoignez notre communauté d'apprentissage
//                 </Text>
//               </div>

//               {/* Avantages de l'inscription */}
//               <div style={{ marginBottom: "30px" }}>
//                 <Title level={3} style={{ color: "#333", marginBottom: "20px" }}>
//                   <StarOutlined style={{ color: "#667eea", marginRight: "10px" }} />
//                   Pourquoi nous rejoindre ?
//                 </Title>
//                 <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
//                   En créant votre compte Nomidya, vous accédez à une plateforme d'apprentissage
//                   innovante conçue pour vous accompagner dans votre développement professionnel
//                   et personnel.
//                 </Paragraph>
//               </div>

//               {/* Fonctionnalités */}
//               <Row gutter={[20, 20]}>
//                 <Col span={12}>
//                   <div style={{ textAlign: "center", padding: "20px" }}>
//                     <BookOutlined style={{ fontSize: "24px", color: "#667eea", marginBottom: "10px" }} />
//                     <div style={{ color: "#333", fontWeight: "bold" }}>Cours Gratuits</div>
//                     <div style={{ color: "#666", fontSize: "12px" }}>Accès à nos formations</div>
//                   </div>
//                 </Col>
//                 <Col span={12}>
//                   <div style={{ textAlign: "center", padding: "20px" }}>
//                     <SecurityScanOutlined style={{ fontSize: "24px", color: "#764ba2", marginBottom: "10px" }} />
//                     <div style={{ color: "#333", fontWeight: "bold" }}>Sécurisé</div>
//                     <div style={{ color: "#666", fontSize: "12px" }}>Données protégées</div>
//                   </div>
//                 </Col>
//                 <Col span={12}>
//                   <div style={{ textAlign: "center", padding: "20px" }}>
//                     <TeamOutlined style={{ fontSize: "24px", color: "#f093fb", marginBottom: "10px" }} />
//                     <div style={{ color: "#333", fontWeight: "bold" }}>Communauté</div>
//                     <div style={{ color: "#666", fontSize: "12px" }}>Échangez avec d'autres</div>
//                   </div>
//                 </Col>
//                 <Col span={12}>
//                   <div style={{ textAlign: "center", padding: "20px" }}>
//                     <TrophyOutlined style={{ fontSize: "24px", color: "#667eea", marginBottom: "10px" }} />
//                     <div style={{ color: "#333", fontWeight: "bold" }}>Certifications</div>
//                     <div style={{ color: "#666", fontSize: "12px" }}>Validez vos acquis</div>
//                   </div>
//                 </Col>
//               </Row>

//               {/* Citation motivante */}
//               <div
//                 style={{
//                   background: "linear-gradient(45deg, #667eea, #764ba2)",
//                   borderRadius: "15px",
//                   padding: "20px",
//                   textAlign: "center",
//                   marginTop: "30px",
//                   color: "white",
//                 }}
//               >
//                 <BulbOutlined style={{ fontSize: "20px", marginBottom: "10px" }} />
//                 <Text style={{ color: "white", fontStyle: "italic", fontSize: "16px", display: "block" }}>
//                   "Commencez votre voyage d'apprentissage dès aujourd'hui et
//                   transformez votre avenir professionnel."
//                 </Text>
//               </div>
//             </div>
//           </Col>

//           {/* Section Inscription */}
//           <Col xs={24} lg={12}>
//             <div style={{ display: "flex", justifyContent: "center" }}>
//               <Card
//                 style={{
//                   width: "100%",
//                   maxWidth: "450px",
//                   background: "rgba(255, 255, 255, 0.95)",
//                   borderRadius: "20px",
//                   boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
//                   backdropFilter: "blur(10px)",
//                   border: "none",
//                 }}
//                 bodyStyle={{ padding: "40px" }}
//               >
//                 {/* Header d'inscription */}
//                 <div style={{ textAlign: "center", marginBottom: "30px" }}>
//                   <img
//                     src="/img/nomidya.png"
//                     alt="Nomidya"
//                     style={{ width: "120px", marginBottom: "20px" }}
//                   />
//                   <Title level={2} style={{ color: "#333", marginBottom: "10px" }}>
//                     Créer un compte
//                   </Title>
//                   <Text style={{ color: "#666" }}>
//                     Rejoignez des milliers d'apprenants sur Nomidya
//                   </Text>
//                 </div>

//                 {/* Formulaire d'inscription */}
//                 <Form
//                   form={form}
//                   name="register"
//                   layout="vertical"
//                   onFinish={handleRegister}
//                   style={{ width: "100%" }}
//                 >
//                   {/* Nom d'utilisateur */}
//                   <Form.Item
//                     name="username"
//                     rules={[
//                       { required: true, message: "Veuillez entrer votre nom d'utilisateur !" },
//                       { min: 3, message: "Le nom d'utilisateur doit contenir au moins 3 caractères !" },
//                       { max: 20, message: "Le nom d'utilisateur ne peut pas dépasser 20 caractères !" },
//                       {
//                         pattern: /^[a-zA-Z0-9_]+$/,
//                         message: "Le nom d'utilisateur ne peut contenir que des lettres, chiffres et underscores !"
//                       }
//                     ]}
//                   >
//                     <Input
//                       prefix={<UserOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
//                       placeholder="Nom d'utilisateur"
//                       size="large"
//                       onChange={(e) => setUsername(e.target.value)}
//                       style={{
//                         borderRadius: "10px",
//                         border: "2px solid #f0f0f0",
//                         padding: "12px",
//                       }}
//                     />
//                   </Form.Item>

//                   {/* Email */}
//                   <Form.Item
//                     name="email"
//                     rules={[
//                       { required: true, message: "Veuillez entrer votre email !" },
//                       { type: "email", message: "Veuillez entrer un email valide !" }
//                     ]}
//                   >
//                     <Input
//                       prefix={<MailOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
//                       placeholder="Adresse email"
//                       size="large"
//                       onChange={(e) => setEmail(e.target.value)}
//                       style={{
//                         borderRadius: "10px",
//                         border: "2px solid #f0f0f0",
//                         padding: "12px",
//                       }}
//                     />
//                   </Form.Item>

//                   {/* Mot de passe */}
//                   <Form.Item
//                     name="password"
//                     rules={[
//                       { required: true, message: "Veuillez entrer votre mot de passe !" },
//                       { min: 8, message: "Le mot de passe doit contenir au moins 8 caractères !" },
//                       { max: 40, message: "Le mot de passe ne peut pas dépasser 40 caractères !" },
//                       {
//                         validator: (_, value) => {
//                           if (!value || checkPasswordStrength(value)) {
//                             return Promise.resolve();
//                           }
//                           return Promise.reject(new Error('Le mot de passe ne respecte pas les critères de sécurité !'));
//                         }
//                       }
//                     ]}
//                   >
//                     <Input.Password
//                       prefix={<LockOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
//                       placeholder="Mot de passe"
//                       size="large"
//                       onChange={(e) => {
//                         setPassword(e.target.value);
//                         checkPasswordStrength(e.target.value);
//                       }}
//                       iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
//                       style={{
//                         borderRadius: "10px",
//                         border: "2px solid #f0f0f0",
//                         padding: "12px",
//                       }}
//                     />
//                   </Form.Item>

//                   {/* Indicateur de force du mot de passe */}
//                   {password && (
//                     <div style={{ marginBottom: "20px" }}>
//                       <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
//                         <Text style={{ fontSize: "12px", color: "#666" }}>Force du mot de passe</Text>
//                         <Text style={{ fontSize: "12px", color: getPasswordStrengthColor() }}>
//                           {getPasswordStrengthText()}
//                         </Text>
//                       </div>
//                       <Progress
//                         percent={passwordStrength}
//                         strokeColor={getPasswordStrengthColor()}
//                         showInfo={false}
//                         size="small"
//                       />
//                       <div style={{ marginTop: "10px" }}>
//                         <Text style={{ fontSize: "11px", color: "#666", display: "block" }}>Critères requis :</Text>
//                         <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "5px" }}>
//                           <Text style={{ fontSize: "10px", color: passwordCriteria.length ? "#52c41a" : "#ff4d4f" }}>
//                             {passwordCriteria.length ? "✓" : "✗"} 8+ caractères
//                           </Text>
//                           <Text style={{ fontSize: "10px", color: passwordCriteria.uppercase ? "#52c41a" : "#ff4d4f" }}>
//                             {passwordCriteria.uppercase ? "✓" : "✗"} Majuscule
//                           </Text>
//                           <Text style={{ fontSize: "10px", color: passwordCriteria.lowercase ? "#52c41a" : "#ff4d4f" }}>
//                             {passwordCriteria.lowercase ? "✓" : "✗"} Minuscule
//                           </Text>
//                           <Text style={{ fontSize: "10px", color: passwordCriteria.number ? "#52c41a" : "#ff4d4f" }}>
//                             {passwordCriteria.number ? "✓" : "✗"} Chiffre
//                           </Text>
//                           <Text style={{ fontSize: "10px", color: passwordCriteria.special ? "#52c41a" : "#ff4d4f" }}>
//                             {passwordCriteria.special ? "✓" : "✗"} Caractère spécial
//                           </Text>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                   {/* Confirmation du mot de passe */}
//                   <Form.Item
//                     name="confirmPassword"
//                     dependencies={['password']}
//                     rules={[
//                       { required: true, message: "Veuillez confirmer votre mot de passe !" },
//                       ({ getFieldValue }) => ({
//                         validator(_, value) {
//                           if (!value || getFieldValue('password') === value) {
//                             return Promise.resolve();
//                           }
//                           return Promise.reject(new Error('Les mots de passe ne correspondent pas !'));
//                         },
//                       }),
//                     ]}
//                   >
//                     <Input.Password
//                       prefix={<LockOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
//                       placeholder="Confirmer le mot de passe"
//                       size="large"
//                       onChange={(e) => setConfirmPassword(e.target.value)}
//                       iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
//                       style={{
//                         borderRadius: "10px",
//                         border: "2px solid #f0f0f0",
//                         padding: "12px",
//                       }}
//                     />
//                   </Form.Item>

//                   {/* Cases à cocher pour les conditions */}
//                   <div style={{ marginBottom: "20px" }}>
//                     <Form.Item
//                       name="acceptTerms"
//                       valuePropName="checked"
//                       rules={[
//                         {
//                           validator: (_, value) =>
//                             value ? Promise.resolve() : Promise.reject(new Error('Vous devez accepter les conditions d\'utilisation')),
//                         },
//                       ]}
//                     >
//                       <Checkbox
//                         checked={acceptTerms}
//                         onChange={(e) => setAcceptTerms(e.target.checked)}
//                         style={{ fontSize: "14px" }}
//                       >
//                         J'accepte les{" "}
//                         <Link
//                           to="/terms-of-service"
//                           style={{ color: "#667eea", fontWeight: "bold" }}
//                         >
//                           conditions d'utilisation
//                         </Link>
//                       </Checkbox>
//                     </Form.Item>

//                     <Form.Item
//                       name="acceptPrivacy"
//                       valuePropName="checked"
//                       rules={[
//                         {
//                           validator: (_, value) =>
//                             value ? Promise.resolve() : Promise.reject(new Error('Vous devez accepter la politique de confidentialité')),
//                         },
//                       ]}
//                     >
//                       <Checkbox
//                         checked={acceptPrivacy}
//                         onChange={(e) => setAcceptPrivacy(e.target.checked)}
//                         style={{ fontSize: "14px" }}
//                       >
//                         J'accepte la{" "}
//                         <Link
//                           to="/privacy-policy"
//                           style={{ color: "#667eea", fontWeight: "bold" }}
//                         >
//                           politique de confidentialité
//                         </Link>
//                       </Checkbox>
//                     </Form.Item>
//                   </div>

//                   <Form.Item style={{ marginBottom: "20px", marginTop: "30px" }}>
//                     <Button
//                       type="primary"
//                       htmlType="submit"
//                       block
//                       size="large"
//                       loading={loading}
//                       icon={loading && <LoadingOutlined />}
//                       disabled={!acceptTerms || !acceptPrivacy}
//                       style={{
//                         background: acceptTerms && acceptPrivacy
//                           ? "linear-gradient(45deg, #667eea, #764ba2)"
//                           : "#d9d9d9",
//                         border: "none",
//                         borderRadius: "10px",
//                         height: "50px",
//                         fontSize: "16px",
//                         fontWeight: "bold",
//                         boxShadow: acceptTerms && acceptPrivacy
//                           ? "0 4px 15px rgba(102, 126, 234, 0.3)"
//                           : "none",
//                         transition: "all 0.3s ease",
//                       }}
//                       onMouseEnter={(e) => {
//                         if (acceptTerms && acceptPrivacy) {
//                           e.target.style.transform = "translateY(-2px)";
//                           e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.4)";
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         if (acceptTerms && acceptPrivacy) {
//                           e.target.style.transform = "translateY(0)";
//                           e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.3)";
//                         }
//                       }}
//                     >
//                       Créer mon compte
//                     </Button>
//                   </Form.Item>
//                 </Form>

//                 {/* Message d'erreur */}
//                 {errorMessage && !successful && (
//                   <Alert
//                     message="Erreur lors de l'inscription"
//                     description={errorMessage}
//                     type="error"
//                     showIcon
//                     style={{
//                       marginTop: "20px",
//                       borderRadius: "10px",
//                       border: "none",
//                     }}
//                   />
//                 )}

//                 {/* Lien vers la connexion */}
//                 <div style={{ textAlign: "center", marginTop: "30px" }}>
//                   <Text style={{ color: "#666" }}>
//                     Vous avez déjà un compte ?{" "}
//                     <Link
//                       to="/login"
//                       style={{
//                         color: "#667eea",
//                         fontWeight: "bold",
//                         textDecoration: "none"
//                       }}
//                     >
//                       Se connecter
//                     </Link>
//                   </Text>
//                 </div>

//                 {/* Footer */}
//                 <div style={{ textAlign: "center", marginTop: "20px" }}>
//                   <Text style={{ color: "#999", fontSize: "12px" }}>
//                     © 2024 Nomidya. Tous droits réservés.
//                   </Text>
//                 </div>
//               </Card>
//             </div>
//           </Col>
//         </Row>
//       </div>
//     </div>
//   );
// };

// export default Register;

import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Form, Input, Button, Card, Typography, Alert, Row, Col, Checkbox, Tooltip, Progress, message } from "antd";
import {
  UserOutlined,
  LockOutlined,
  MailOutlined,
  LoadingOutlined,
  BookOutlined,
  TeamOutlined,
  TrophyOutlined,
  RocketOutlined,
  StarOutlined,
  BulbOutlined,
  CheckCircleOutlined,
  SecurityScanOutlined,
  InfoCircleOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  IdcardOutlined
} from "@ant-design/icons";

import { register } from "../actions/auth";

const { Title, Paragraph, Text } = Typography;

const Register = () => {
  const [form] = Form.useForm();
  const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState(""); // ✅ NOUVEAU
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptPrivacy, setAcceptPrivacy] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordCriteria, setPasswordCriteria] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  });

  const { message: errorMessage } = useSelector(state => state.message);
  const dispatch = useDispatch();

  // Fonction pour vérifier la force du mot de passe
  const checkPasswordStrength = (password) => {
    const criteria = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };

    setPasswordCriteria(criteria);

    const score = Object.values(criteria).filter(Boolean).length;
    setPasswordStrength((score / 5) * 100);

    return score >= 4;
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength < 40) return '#ff4d4f';
    if (passwordStrength < 70) return '#faad14';
    return '#52c41a';
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength < 40) return 'Faible';
    if (passwordStrength < 70) return 'Moyen';
    return 'Fort';
  };

  const handleRegister = (values) => {
    if (!acceptTerms || !acceptPrivacy) {
      message.error("Veuillez accepter les conditions d'utilisation et la politique de confidentialité.");
      return;
    }

    if (!checkPasswordStrength(values.password)) {
      message.error("Le mot de passe ne respecte pas les critères de sécurité requis.");
      return;
    }

    setLoading(true);
    setSuccessful(false);

    // ✅ NOUVEAU : passer values.fullName en 7e paramètre (optionnel)
    dispatch(register(
      values.username,
      values.email,
      values.password,
      values.confirmPassword,
      acceptTerms,
      acceptPrivacy,
      values.fullName // ← peut être undefined ou string vide
    ))
      .then(() => {
        setSuccessful(true);
        setLoading(false);
      })
      .catch(() => {
        setSuccessful(false);
        setLoading(false);
      });
  };

  if (successful) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <Card
          style={{
            width: "100%",
            maxWidth: "500px",
            background: "rgba(255, 255, 255, 0.95)",
            borderRadius: "20px",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(10px)",
            border: "none",
            textAlign: "center",
          }}
          bodyStyle={{ padding: "50px" }}
        >
          <div
            style={{
              background: "linear-gradient(45deg, #52c41a, #73d13d)",
              borderRadius: "50%",
              width: "80px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 30px",
              boxShadow: "0 10px 30px rgba(82, 196, 26, 0.3)",
            }}
          >
            <CheckCircleOutlined style={{ fontSize: "32px", color: "white" }} />
          </div>

          <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
            Inscription réussie !
          </Title>

          <Paragraph style={{ color: "#666", fontSize: "16px", marginBottom: "30px" }}>
            Votre compte a été créé avec succès. Un email de confirmation a été envoyé à votre adresse.
            Veuillez confirmer votre email pour commencer votre parcours d'apprentissage sur Nomidya.
          </Paragraph>

          <Link to="/login">
            <Button
              type="primary"
              size="large"
              style={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                border: "none",
                borderRadius: "10px",
                height: "50px",
                fontSize: "16px",
                fontWeight: "bold",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                minWidth: "200px",
              }}
            >
              Se connecter
            </Button>
          </Link>
        </Card>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
        display: "flex",
        alignItems: "center",
        padding: "20px 0",
      }}
    >
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        <Row gutter={[40, 40]} align="middle">
          {/* Section Description */}
          <Col xs={24} lg={12}>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.95)",
                borderRadius: "20px",
                padding: "40px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(10px)",
              }}
            >
              {/* Logo et titre principal */}
              <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <div
                  style={{
                    background: "linear-gradient(45deg, #667eea, #764ba2)",
                    borderRadius: "50%",
                    width: "80px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px",
                    boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
                  }}
                >
                  <RocketOutlined style={{ fontSize: "32px", color: "white" }} />
                </div>
                <Title
                  level={1}
                  style={{
                    background: "linear-gradient(45deg, #667eea, #764ba2)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    marginBottom: "10px",
                    fontSize: "2.5em"
                  }}
                >
                  NOMIDYA
                </Title>
                <Text style={{ fontSize: "18px", color: "#666" }}>
                  Rejoignez notre communauté d'apprentissage
                </Text>
              </div>

              {/* Avantages de l'inscription */}
              <div style={{ marginBottom: "30px" }}>
                <Title level={3} style={{ color: "#333", marginBottom: "20px" }}>
                  <StarOutlined style={{ color: "#667eea", marginRight: "10px" }} />
                  Pourquoi nous rejoindre ?
                </Title>
                <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                  En créant votre compte Nomidya, vous accédez à une plateforme d'apprentissage
                  innovante conçue pour vous accompagner dans votre développement professionnel
                  et personnel.
                </Paragraph>
              </div>

              {/* Fonctionnalités */}
              <Row gutter={[20, 20]}>
                <Col span={12}>
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <BookOutlined style={{ fontSize: "24px", color: "#667eea", marginBottom: "10px" }} />
                    <div style={{ color: "#333", fontWeight: "bold" }}>Cours Gratuits</div>
                    <div style={{ color: "#666", fontSize: "12px" }}>Accès à nos formations</div>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <SecurityScanOutlined style={{ fontSize: "24px", color: "#764ba2", marginBottom: "10px" }} />
                    <div style={{ color: "#333", fontWeight: "bold" }}>Sécurisé</div>
                    <div style={{ color: "#666", fontSize: "12px" }}>Données protégées</div>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <TeamOutlined style={{ fontSize: "24px", color: "#f093fb", marginBottom: "10px" }} />
                    <div style={{ color: "#333", fontWeight: "bold" }}>Communauté</div>
                    <div style={{ color: "#666", fontSize: "12px" }}>Échangez avec d'autres</div>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <TrophyOutlined style={{ fontSize: "24px", color: "#667eea", marginBottom: "10px" }} />
                    <div style={{ color: "#333", fontWeight: "bold" }}>Certifications</div>
                    <div style={{ color: "#666", fontSize: "12px" }}>Validez vos acquis</div>
                  </div>
                </Col>
              </Row>

              {/* Citation motivante */}
              <div
                style={{
                  background: "linear-gradient(45deg, #667eea, #764ba2)",
                  borderRadius: "15px",
                  padding: "20px",
                  textAlign: "center",
                  marginTop: "30px",
                  color: "white",
                }}
              >
                <BulbOutlined style={{ fontSize: "20px", marginBottom: "10px" }} />
                <Text style={{ color: "white", fontStyle: "italic", fontSize: "16px", display: "block" }}>
                  "Commencez votre voyage d'apprentissage dès aujourd'hui et
                  transformez votre avenir professionnel."
                </Text>
              </div>
            </div>
          </Col>

          {/* Section Inscription */}
          <Col xs={24} lg={12}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Card
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  background: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "20px",
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                  backdropFilter: "blur(10px)",
                  border: "none",
                }}
                bodyStyle={{ padding: "40px" }}
              >
                {/* Header d'inscription */}
                <div style={{ textAlign: "center", marginBottom: "30px" }}>
                  <img
                    src="/img/nomidya.png"
                    alt="Nomidya"
                    style={{ width: "120px", marginBottom: "20px" }}
                  />
                  <Title level={2} style={{ color: "#333", marginBottom: "10px" }}>
                    Créer un compte
                  </Title>
                  <Text style={{ color: "#666" }}>
                    Rejoignez des milliers d'apprenants sur Nomidya
                  </Text>
                </div>

                {/* Formulaire d'inscription */}
                <Form
                  form={form}
                  name="register"
                  layout="vertical"
                  onFinish={handleRegister}
                  style={{ width: "100%" }}
                >
                  {/* Nom d'utilisateur */}
                  <Form.Item
                    name="username"
                    rules={[
                      { required: true, message: "Veuillez entrer votre nom d'utilisateur !" },
                      { min: 3, message: "Le nom d'utilisateur doit contenir au moins 3 caractères !" },
                      { max: 20, message: "Le nom d'utilisateur ne peut pas dépasser 20 caractères !" },
                      {
                        pattern: /^[a-zA-Z0-9_]+$/,
                        message: "Le nom d'utilisateur ne peut contenir que des lettres, chiffres et underscores !"
                      }
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
                      placeholder="Nom d'utilisateur"
                      size="large"
                      onChange={(e) => setUsername(e.target.value)}
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #f0f0f0",
                        padding: "12px",
                      }}
                    />
                  </Form.Item>

                  {/* ✅ NOUVEAU : Nom complet (optionnel) */}
                  <Form.Item
                    name="fullName"
                    rules={[
                      { max: 100, message: "Le nom complet ne peut pas dépasser 100 caractères !" }
                    ]}
                    extra={
                      <Text style={{ fontSize: "11px", color: "#999", fontStyle: "italic" }}>
                        💡 Optionnel — utilisé pour vos certificats et votre profil. Modifiable plus tard.
                      </Text>
                    }
                  >
                    <Input
                      prefix={<IdcardOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
                      placeholder="Nom complet (optionnel) — ex: Taoufik Malaoui"
                      size="large"
                      onChange={(e) => setFullName(e.target.value)}
                      maxLength={100}
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #f0f0f0",
                        padding: "12px",
                      }}
                    />
                  </Form.Item>

                  {/* Email */}
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Veuillez entrer votre email !" },
                      { type: "email", message: "Veuillez entrer un email valide !" }
                    ]}
                  >
                    <Input
                      prefix={<MailOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
                      placeholder="Adresse email"
                      size="large"
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #f0f0f0",
                        padding: "12px",
                      }}
                    />
                  </Form.Item>

                  {/* Mot de passe */}
                  <Form.Item
                    name="password"
                    rules={[
                      { required: true, message: "Veuillez entrer votre mot de passe !" },
                      { min: 8, message: "Le mot de passe doit contenir au moins 8 caractères !" },
                      { max: 40, message: "Le mot de passe ne peut pas dépasser 40 caractères !" },
                      {
                        validator: (_, value) => {
                          if (!value || checkPasswordStrength(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Le mot de passe ne respecte pas les critères de sécurité !'));
                        }
                      }
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
                      placeholder="Mot de passe"
                      size="large"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        checkPasswordStrength(e.target.value);
                      }}
                      iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #f0f0f0",
                        padding: "12px",
                      }}
                    />
                  </Form.Item>

                  {/* Indicateur de force du mot de passe */}
                  {password && (
                    <div style={{ marginBottom: "20px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                        <Text style={{ fontSize: "12px", color: "#666" }}>Force du mot de passe</Text>
                        <Text style={{ fontSize: "12px", color: getPasswordStrengthColor() }}>
                          {getPasswordStrengthText()}
                        </Text>
                      </div>
                      <Progress
                        percent={passwordStrength}
                        strokeColor={getPasswordStrengthColor()}
                        showInfo={false}
                        size="small"
                      />
                      <div style={{ marginTop: "10px" }}>
                        <Text style={{ fontSize: "11px", color: "#666", display: "block" }}>Critères requis :</Text>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "5px" }}>
                          <Text style={{ fontSize: "10px", color: passwordCriteria.length ? "#52c41a" : "#ff4d4f" }}>
                            {passwordCriteria.length ? "✓" : "✗"} 8+ caractères
                          </Text>
                          <Text style={{ fontSize: "10px", color: passwordCriteria.uppercase ? "#52c41a" : "#ff4d4f" }}>
                            {passwordCriteria.uppercase ? "✓" : "✗"} Majuscule
                          </Text>
                          <Text style={{ fontSize: "10px", color: passwordCriteria.lowercase ? "#52c41a" : "#ff4d4f" }}>
                            {passwordCriteria.lowercase ? "✓" : "✗"} Minuscule
                          </Text>
                          <Text style={{ fontSize: "10px", color: passwordCriteria.number ? "#52c41a" : "#ff4d4f" }}>
                            {passwordCriteria.number ? "✓" : "✗"} Chiffre
                          </Text>
                          <Text style={{ fontSize: "10px", color: passwordCriteria.special ? "#52c41a" : "#ff4d4f" }}>
                            {passwordCriteria.special ? "✓" : "✗"} Caractère spécial
                          </Text>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Confirmation du mot de passe */}
                  <Form.Item
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[
                      { required: true, message: "Veuillez confirmer votre mot de passe !" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Les mots de passe ne correspondent pas !'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined style={{ color: "#667eea", fontSize: "16px", marginRight: "8px" }} />}
                      placeholder="Confirmer le mot de passe"
                      size="large"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #f0f0f0",
                        padding: "12px",
                      }}
                    />
                  </Form.Item>

                  {/* Cases à cocher pour les conditions */}
                  <div style={{ marginBottom: "20px" }}>
                    <Form.Item
                      name="acceptTerms"
                      valuePropName="checked"
                      rules={[
                        {
                          validator: (_, value) =>
                            value ? Promise.resolve() : Promise.reject(new Error('Vous devez accepter les conditions d\'utilisation')),
                        },
                      ]}
                    >
                      <Checkbox
                        checked={acceptTerms}
                        onChange={(e) => setAcceptTerms(e.target.checked)}
                        style={{ fontSize: "14px" }}
                      >
                        J'accepte les{" "}
                        <Link
                          to="/terms-of-service"
                          style={{ color: "#667eea", fontWeight: "bold" }}
                        >
                          conditions d'utilisation
                        </Link>
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="acceptPrivacy"
                      valuePropName="checked"
                      rules={[
                        {
                          validator: (_, value) =>
                            value ? Promise.resolve() : Promise.reject(new Error('Vous devez accepter la politique de confidentialité')),
                        },
                      ]}
                    >
                      <Checkbox
                        checked={acceptPrivacy}
                        onChange={(e) => setAcceptPrivacy(e.target.checked)}
                        style={{ fontSize: "14px" }}
                      >
                        J'accepte la{" "}
                        <Link
                          to="/privacy-policy"
                          style={{ color: "#667eea", fontWeight: "bold" }}
                        >
                          politique de confidentialité
                        </Link>
                      </Checkbox>
                    </Form.Item>
                  </div>

                  <Form.Item style={{ marginBottom: "20px", marginTop: "30px" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      size="large"
                      loading={loading}
                      icon={loading && <LoadingOutlined />}
                      disabled={!acceptTerms || !acceptPrivacy}
                      style={{
                        background: acceptTerms && acceptPrivacy
                          ? "linear-gradient(45deg, #667eea, #764ba2)"
                          : "#d9d9d9",
                        border: "none",
                        borderRadius: "10px",
                        height: "50px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        boxShadow: acceptTerms && acceptPrivacy
                          ? "0 4px 15px rgba(102, 126, 234, 0.3)"
                          : "none",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (acceptTerms && acceptPrivacy) {
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.4)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (acceptTerms && acceptPrivacy) {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.3)";
                        }
                      }}
                    >
                      Créer mon compte
                    </Button>
                  </Form.Item>
                </Form>

                {/* Message d'erreur */}
                {errorMessage && !successful && (
                  <Alert
                    message="Erreur lors de l'inscription"
                    description={errorMessage}
                    type="error"
                    showIcon
                    style={{
                      marginTop: "20px",
                      borderRadius: "10px",
                      border: "none",
                    }}
                  />
                )}

                {/* Lien vers la connexion */}
                <div style={{ textAlign: "center", marginTop: "30px" }}>
                  <Text style={{ color: "#666" }}>
                    Vous avez déjà un compte ?{" "}
                    <Link
                      to="/login"
                      style={{
                        color: "#667eea",
                        fontWeight: "bold",
                        textDecoration: "none"
                      }}
                    >
                      Se connecter
                    </Link>
                  </Text>
                </div>

                {/* Footer */}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <Text style={{ color: "#999", fontSize: "12px" }}>
                    © 2024 Nomidya. Tous droits réservés.
                  </Text>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Register;